const baseUrl =
  // "http://localhost:8080/";
  "https://api-third-shot-score-684526581556.asia-south1.run.app/";

export const getAllSportDetails = async () => {
  const data = await fetch(`${baseUrl}sports`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllCourtsData = async () => {
  const data = await fetch(`${baseUrl}pickleball/courts`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getActiveDisplaySettings = async (slot = 1) => {
  const s = Number(slot) === 2 ? 2 : 1;
  const data = await fetch(`${baseUrl}display-settings/active?slot=${s}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
